<template>
    <Dialog :value="value" @input="$listeners.input" title="Sincronização" :show-close-button="!loading">
        <ul class="custom-list">
            <li v-for="(item, index) in items_to_sync" :key="index" :class="item.state">{{ item.titulo }} {{ item.error ? `: ${item.error}`:'' }}</li>
        </ul>
        <v-row slot="buttons" class="justify-center">
            <v-btn id="ButtonSincronizar" color="primary" class="align-self-center" :disabled="loading" @click="sincronizar()">{{ loading ? 'Sincronizando...' : 'Sincronizar' }}</v-btn>
        </v-row>
    </Dialog>
</template>
<script>
  import { get } from 'lodash'

  const States = {
    WAITING: '',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error'
  }

  export default {
    name: 'DialogSincronizacao',
    props: { value: Boolean },
    data () {
      return {
        loading: false,
        items_to_sync: this.itemsToSync()
      }
    },
    watch: {
      value (open) {
        if (!open) {
          this.items_to_sync = this.itemsToSync()
        }
      }
    },
    methods: {
      itemsToSync () {
        return [
          {
            titulo: 'Histórico de Vendas',
            callable: this.sincronizar_historico,
            state: States.WAITING,
            error: ''
          }
        ]
      },
      async sincronizar () {
        this.loading = true
        this.items_to_sync = this.itemsToSync()
        await this.executePool()
        this.loading = false
      },
      async executePool (index = 0) {
        if (index + 1 <= this.items_to_sync.length) {
          const item = this.items_to_sync[index]
          try {
            item.state = States.LOADING
            await item.callable()
            item.state = States.SUCCESS
          } catch (exception) {
            item.error = exception
            item.state = States.ERROR
          }
          this.executePool(index + 1)
        }
      },
      async sincronizar_historico (index) {
        // noinspection JSCheckFunctionSignatures
        return this.$http.get('/proposta/sincronizar', { options: { silent: true } })
          .then(res => {
            if (res.data['pedidos_salvos'] === 0) {
              throw Error('Nenhuma nova venda recebida!')
            }
          })
          .catch(err => {
            throw get(err, 'response.data.Msg_Erro', err.message)
          })
      }
    }
  }
</script>
<style scoped></style>
